"use client"

import React from "react"
import { Navigate } from "react-router-dom"
import { useAuth } from "../context/AuthContext"

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth()

  if (loading) {
    return React.createElement("div", { className: "loading" }, React.createElement("div", { className: "spinner" }))
  }

  if (!user) {
    return React.createElement(Navigate, { to: "/login", replace: true })
  }

  return children
}

export default ProtectedRoute
